const endpoint = `/api/file`;

export const endpoints = {
  uploadFile: `${endpoint}/upload`,
  getFileById: (id) => `${endpoint}/${id}`,
  validateProfessionalBulkFiles: `${endpoint}/professional-bulk-file-validation`,
  searchFiles: `${endpoint}/index`,
};
